const map = {
	"./bell.wav": 9294,
	"./blip.wav": 7896,
	"./cash_register.wav": 8708,
	"./horn.wav": 1134,
	"./space.wav": 6137,
	"./synth.wav": 8533,
	"./tinkle.wav": 9336,
	"./water.wav": 2494,
	"./woosh.wav": 6899,
	"./yoo-hoo.mp3": 2077
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7217;